import LetterElementModel from 'letter/model/letter_element_model'

export default function fabricObjectToShapeLetterElement(fabricObject, letterElement) {
  let shapeColor
  if (fabricObject.fill === 'rgb(0,0,0)') {
    shapeColor = '#000000'
  } else {
    shapeColor = fabricObject.fill
  }

  const options = {
    type: 'rectangle',
    sortId: fabricObject._sortId,
    x: fabricObject.left,
    y: fabricObject.top,

    metaData: {
      color: shapeColor,
      width: fabricObject.width,
      height: fabricObject.height,
    },
  }

  if (letterElement) {
    letterElement.set(options)
    return letterElement
  } else {
    return new LetterElementModel(options)
  }
}
